import {  Form, Input,  Select} from "antd";
import { filterOption,  requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useLoaderData, } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";

export default function () {
  const data = useLoaderData();
  const loadFn = (form) =>
    form.setFieldsValue({ ...data, requiredCourseType: data.requiredCourseType?.id });

  const [courseTypes, setCourseTypes] = useState([]);
  useEffect(() => {
    axiosInstance
      .get("courseType", { params: { pageSize: 99999 } })
      .then(({ data }) => setCourseTypes(data.data.map((x) => ({ label: x.title, value: x.id }))));
  }, []);

  return (
    <SimpleFormPage
      title="Modifica categoria veicolo"
      loadFn={loadFn}
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item label="Nome" rules={[requiredField]} name="name">
        <Input />
      </Form.Item>
      <Form.Item label="Corso di abilitazione (se richiesto)" name="requiredCourseType">
        <Select options={courseTypes} showSearch filterOption={filterOption} />
      </Form.Item>
    </SimpleFormPage>
  );
}
